<template>
  <div class="tab-page">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="pods">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Pods
          </div>
          <div class="label-desc">pod list</div>
        </div>
        <Pods v-if="activeName === 'pods'" />
      </el-tab-pane>
      <el-tab-pane name="nodes">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Nodes
          </div>
          <div class="label-desc">node list</div>
        </div>
        <Nodes v-if="activeName === 'nodes'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Pods from '@/components/manage/devices/Pods'
import Nodes from '@/components/manage/devices/Nodes'
import $ from 'jquery'
export default {
  data() {
    return {
      activeName: 'pods',
      screenWidth: 0
    }
  },
  components: {
    Pods,
    Nodes
  },
  mounted: function() {
    this.getScreenWidth()
    window.addEventListener('resize', this.getScreenWidth)
    setTimeout(() => {
      this.toggleNavArrow()
      if (this.screenWidth <= 1023) {
        this.listenNavBtnClick()
      }
    }, 50)
  },
  watch: {
    activeName() {
      this.toggleNavArrow()
    }
  },
  methods: {
    listenNavBtnClick() {
      var nextBtn = document.getElementsByClassName('el-tabs__nav-next')
      nextBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-next').hide()
          $('.el-tabs__nav-prev').show()
        },
        true
      )
      var prevBtn = document.getElementsByClassName('el-tabs__nav-prev')
      prevBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-prev').hide()
          $('.el-tabs__nav-next').show()
        },
        true
      )
    },
    toggleNavArrow() {
      if (this.activeName === 'nodes') {
        $('.el-tabs__nav-next').hide()
      } else {
        $('.el-tabs__nav-next').show()
      }
      if (this.activeName === 'pods') {
        $('.el-tabs__nav-prev').hide()
      } else {
        $('.el-tabs__nav-prev').show()
      }
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  }
}
</script>
